// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__kTr-g","list":"PatternAutocomplete_list__1lKOL"};